export const environment = {
  env: 'PROD',
  cookieDomain: 'maplix.com',
  production: true,
  apps: {
    root: 'https://www.maplix.com/account/',
    auth: 'https://www.maplix.com/account/',
    home: 'https://www.maplix.com/dashboard/',
    editor: 'https://www.maplix.com/editor/',
    surveyViewer: 'https://www.maplix.com/survey/',
    mapViewer: 'https://www.maplix.com/map/',
  },
  api: `https://api.maplix.com/`,
  stitchId: 'maplix-account-prod-ukpqz',
  plausible: {
    domain: 'maplix.com',
  },
  microsoft: {
    clientId: 'cf9ac84e-e2c9-4110-ab53-cfb386c21420',
  },
};
